// Import icons from src/assets/icons
import speaker_icon from '../assets/icons/speaker_icon.svg';
import bell_icon from '../assets/icons/bell_icon.svg';
import volume_controller from '../assets/icons/volume_controller.svg';
import volume_controller_plain from '../assets/icons/volume_controller_plain.svg';
import heart_music from '../assets/icons/heart_music.svg';
import star_music from '../assets/icons/star_music.svg';
import hash_tag from '../assets/icons/hash_tag.svg';
import mic from '../assets/icons/mic.svg';
import boom_mic from '../assets/icons/boom_mic.svg';
import cd_case from '../assets/icons/cd_case.svg';
import music_cart from '../assets/icons/music_cart.svg';
import upload_music from '../assets/icons/upload_music.svg';
import radio_box from '../assets/icons/radio_box.svg';
import premium from '../assets/icons/premium.svg';
import search from '../assets/icons/search.svg';
import votes from '../assets/icons/votes.svg';
import music_library from '../assets/icons/music_library.svg';
import circle from '../assets/icons/circle.svg';
import disabled_mic from '../assets/icons/disabled_mic.svg';
import pause from '../assets/icons/pause.svg';
import play from '../assets/icons/play.svg';
import repeat from '../assets/icons/repeat.svg';
import volume from '../assets/icons/volume.svg';
import fullscreen from '../assets/icons/fullscreen.svg';
import filter from '../assets/icons/filter.svg';
import like from '../assets/icons/like.svg';
import chat from '../assets/icons/chat.svg';
import notes from '../assets/icons/notes.svg';
import note from '../assets/icons/note.svg';
import note_strikethrough from '../assets/icons/note_strikethrough.svg';
import star_music_plain from '../assets/icons/star_music_plain.svg';
import close from '../assets/icons/close.svg';
import trash from '../assets/icons/trash.svg'
import document from '../assets/icons/document.svg'
import clock from '../assets/icons/clock.svg'
import calendar from '../assets/icons/calendar.svg'
import comment from '../assets/icons/comment.svg';
import love from '../assets/icons/love.svg';
import pin from '../assets/icons/pin.svg'
import music from '../assets/icons/music.svg';
import recording from '../assets/icons/recording.svg';
import vc_standalone from '../assets/svgs/vocal_centric_standalone.svg';
import images from '../assets/icons/images.svg';
import pdf_icon from '../assets/icons/pdf_icon.svg';
import speaker from '../assets/icons/speaker.svg';
import clipboard from '../assets/icons/clipboard.svg';


const useBrandIcon = () => {
    return {
        bell_icon,
        boom_mic,
        calendar,
        cd_case,
        chat,
        circle,
        clipboard,
        clock,
        close,
        comment,
        disabled_mic,
        document,
        filter,
        fullscreen,
        hash_tag,
        heart_music,
        images,
        like,
        love,
        mic,
        music,
        music_cart,
        music_library,
        note,
        note_strikethrough,
        notes,
        pause,
        pdf_icon,
        pin,
        play,
        premium,
        radio_box,
        recording,
        repeat,
        search,
        speaker,
        speaker_icon,
        star_music,
        star_music_plain,
        trash,
        upload_music,
        vc_standalone,
        volume,
        volume_controller,
        volume_controller_plain,
        votes
    };
};

export default useBrandIcon;